import { CreateSeedAudiencesLookalikeSizeProps } from 'types/audiences';
import LookalikeSizeView from './CreateSeedAudiencesLookalikeSize.View';

const INTERVAL = 0.01;
const RECOMMENDED_VALUE = 0.1;
const MAX_AVAILABLE_SIZE_OPTIONS = 20;
const availableOptions = [...Array(MAX_AVAILABLE_SIZE_OPTIONS)].map(
  (_, val) => (val + 1) * INTERVAL,
);

const CreateSeedAudiencesLookalikeSize = (props: CreateSeedAudiencesLookalikeSizeProps) => {
  const { loading, disabled = false, sizes = [] } = props;

  const options = availableOptions.map((option) => {
    const optionDisabled = sizes.includes(option);
    const recommended = option === RECOMMENDED_VALUE;
    const label = Number.parseInt(`${option * 100}`, 10);
    const showRecommended = recommended && !optionDisabled && !sizes.length;

    let sideLabel = '';
    if (showRecommended) sideLabel = ' (Recommended)';
    if (optionDisabled) sideLabel = ' - Already generated';

    return {
      disabled: optionDisabled,
      value: `${option}`,
      label: `${label}%${sideLabel}`,
    };
  });

  return <LookalikeSizeView options={options} loading={loading} disabled={disabled} />;
};

export default CreateSeedAudiencesLookalikeSize;
